/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductSnipcartButton from './ProductSnipcartButton';

/** A button to buy via Snipcart. */
export default function ProductRequestSampleWithSnipcartButton({
  product,
  ...rest
}) {
  return (
    <ProductSnipcartButton product={product} data-item-price={0} {...rest}>
      <Trans>Request sample</Trans>
    </ProductSnipcartButton>
  );
}

export const fragment = graphql`
  fragment bb_ProductRequestSampleWithSnipcartButton on Bottlebooks_Product {
    ...bb_ProductSnipcartButton
  }
`;

ProductRequestSampleWithSnipcartButton.fragment = gql`
  fragment ProductRequestSampleWithSnipcartButton on Product {
    ...ProductSnipcartButton
  }
  ${ProductSnipcartButton.fragment}
`;
